export const meta = {
  id: "FW-16",
  name: "Emberhall",
  slug: "emberhall",
  title: "Emberhall — a Fable World: restaurant launch page",
  description:
    "An original restaurant landing page designed by Fable: a grid that breaks with appetite, a molten shader hero, char and ember."
} as const;

export default meta;
